import { render, staticRenderFns } from "./components.model.vue?vue&type=template&id=18789e98&scoped=true"
import script from "./components.model.vue?vue&type=script&lang=js"
export * from "./components.model.vue?vue&type=script&lang=js"
import style0 from "./components.model.vue?vue&type=style&index=0&id=18789e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18789e98",
  null
  
)

export default component.exports